import moment from "moment";
import common from '../../common.module.css';
import Text from "@UI/New/Text";
import classNames from "classnames";
import Button from "@UI/New/Button";
import { getLinkAndTextTypeOfLesson } from "../../helpers/getLinkAndTextTypeOfLesson";
import { useSelector } from "react-redux";
import { getLinkToMeeting } from "@/helpers/new/getLinkToMeeting";

export const ContentForChildren = ({report}) => {
    const lesson = getLinkAndTextTypeOfLesson({lesson: report?.access_journal})
    const hideLinkInLessonInTimetable = useSelector(store => store.settings.hideLinkInLessonInTimetable);
    
    return (
       <div className={common.wrapper}>
            <div className={classNames(common.row, common.noRowInMobile)}>
                <Text 
                    texts = {report.seminariansNames} 
                />
                {
                    !!report?.isOffline && (
                         <Text 
                            type='grey'
                            texts = {[report.audienceNumber]} 
                        />
                    )
                }
            </div>
            <div className={common.row}>
                <Text 
                    type='lightGray'
                    title='Дата урока'
                    texts = {[moment(report?.date_conference).format('DD.MM.YYYY')]} 
                />
                <Text 
                    type='lightGray'
                    title='Начало'
                    texts = {[report?.start_time]} 
                />
                <Text 
                    type='lightGray'
                    title='Окончание'
                    texts = {[report?.end_time]} 
                />
            </div>
            {
                    !!getLinkToMeeting({report}) && hideLinkInLessonInTimetable != '1' && (
                        <div className={common.row}>
                            <Text 
                                type='lightGray'
                                title='Скопировать ссылку на встречу'
                                texts = {[getLinkToMeeting({report})]} 
                                copy = {
                                    {
                                        show: true,
                                        copyText: 'Ссылка успешно скопирована'
                                    }
                                }
                            />
                        </div>
                )
            }
            {
                !!lesson && (
                    <div className={common.lessonLinkRow}>
                        <span>{lesson.textType + lesson.name ?? ''}</span>
                        <a href={lesson.link}>
                            <Button 
                                color='secondary'
                                onClick={()=>{}}
                                className={common.button}>
                                Перейти
                            </Button>
                        </a> 
                    </div>
                )
            }
            <div className={common.row}>
                {/* <Text 
                    type='lightGray'
                    title='Скидка'
                    texts = {['10%']} 
                    className={common.discount}
                /> */}
                <Text 
                    type='lightGray'
                    title='Комментарий'
                    texts = {[report?.comment_to_dz]} 
                    className={common.comment}
                />
            </div>
       </div>
    )
}